import { useMemo, useState } from "react";
import Localized from "../../../../Localized";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import ButtonAdd from "./ButtonAdd";
import './style.scss';
import { useMediaQuery } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";

import { activatePromo } from "../../../../redux/slices/orderSlice";

const getColor = (num: string | number) => {
    if(num >= 0 && num < 35) {
        return '#F03226';
    } else if(num>=35 && num < 70) {
        return '#FF9C00';
    } else {
        return '#43DF91';
    }
};

const Item = ({ product, isSelected }) => {
    const { categoryId, pathColor, pathPhoto, title, count, maxCount, prices, isActivatePromo, freePercent } = product;
    const { standart, promo } = prices;

    const { totalCount, maxTotal } = useAppSelector((state: RootState) => state.orderSlice);
    const dispatch = useAppDispatch();

    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const theme2 = useMemo(
        () => createTheme({
        palette: {
            mode: prefersDarkMode ? 'light' : 'light',
            primary: {
                main: '#741BF2',
            },
        },
        }),
        [prefersDarkMode],
    );

    const [changePrice, setPrice] = useState({
        normal: !isActivatePromo
    });
  
    let changePriceStandart: number, changePricePromo: number;

    if(changePrice.normal) {
        if(count===0) {
            changePriceStandart = standart * 1;
            changePricePromo = promo * 1;
        } else {
            changePriceStandart = standart * count;
            changePricePromo = promo * count;
        }
    } else {
        if(count===0) {
            changePricePromo = standart * 1;
            changePriceStandart = promo * 1;
        } else {
            changePricePromo = standart * count;
            changePriceStandart = promo * count;
        }
    }
    
    const changePrices = () => {
        setPrice({
            normal: !changePrice.normal
        });

        dispatch(activatePromo(categoryId));
    }

    const PromoBtn = () => {
        if(promo !== null) {
            return <label className="ticket_promo">
                        <ThemeProvider theme={theme2}>
                            <Checkbox size="small" color="primary" onClick={()=>{changePrices()}} checked={isActivatePromo} />
                            <p className="ticket_promo_text">{Localized.LabelSpecialPriceText}</p>
                        </ThemeProvider>        
                    </label>;
        }
    }

    return(
        <div className="ticket" style={isSelected ? {boxShadow: '0px 0px 5px '+ pathColor} : {}}>
            <div className="ticket_wrapper">
                <div className="ticket_color" style={{background: `${pathColor}`}}></div>
                <div className="ticket_photo" style={{background: `url(${pathPhoto}), ${pathColor}`, backgroundSize: 'cover', backgroundPosition: "center" }}></div>
                <div className="ticket_information">
                    <h1 className="ticket_information_title">{title}</h1>
                    <div className="ticket_information_left">
                        <span className="ticket_information_left_text">{Localized.ItemAvailable}</span>
                        <div className="ticket_information_left_indicator">
                            <div className="ticket_information_left_indicator_actual" style={{width: freePercent > 10 ? (freePercent + '%') : '10%', background: getColor(freePercent)}}></div>
                            <div className="ticket_information_left_indicator_all"></div>
                        </div>
                    </div>
                </div>
                <div className="ticket_right">
                    <div className="ticket_price">
                        <div className="ticket_price_old" style={changePrice.normal ? {display: 'none'} : {display: 'flex'}}>
                            <span className="ticket_price_old_whole">{Math.floor(changePricePromo/100)}</span>
                            <span className="ticket_price_old_fractional">.{String(changePricePromo).slice(-2)}</span>
                            <span className="ticket_price_old_currency">Br</span>
                        </div>
                        <div className="ticket_price_actual">
                            <span className="ticket_price_actual_whole">{Math.floor(changePriceStandart/100)}</span>
                            <span className="ticket_price_actual_fractional">{String(changePriceStandart).slice(-2)}</span>
                            <span className="ticket_price_actual_currency">Br</span>
                        </div>
                    </div>
                    <ButtonAdd 
                        id={categoryId} 
                        count={count}
                        maxCount={maxCount}
                        totalCount={totalCount}
                        maxTotal={maxTotal}
                        isPromo={isActivatePromo}
                    />
                </div>
                {PromoBtn()}
            </div>
        </div>
    );
}

export default Item;
